import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UIArtefakt, UIArtefaktContainer} from '../../../models/uiArtefakt';
import {EventService} from '../../../services/event.service';
import {BehaviorSubject, Observable, combineLatest} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {CalculationService} from '../../../services/calculation.service';

@Component({
    selector: 'lv-beitrag-box',
    templateUrl: './beitrag-box.component.html',
    styleUrls: ['./beitrag-box.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BeitragBoxComponent implements OnInit {
  public beitragBoxData$: Observable<UIArtefakt[]>;
  private _beitragBoxArtefakt$ = new BehaviorSubject<UIArtefaktContainer>(null);
  private _uiArtefakt: UIArtefaktContainer;

  constructor(private _eventService: EventService, private _calculationService: CalculationService) {
  }

  get uiArtefakt(): UIArtefaktContainer {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: UIArtefaktContainer) {
    this._uiArtefakt = uiArtefakt;
    this._beitragBoxArtefakt$.next(uiArtefakt);
  }

  ngOnInit(): void {
    this.beitragBoxData$ = combineLatest<[UIArtefaktContainer, UIArtefaktContainer]>(
        [this._eventService.asyncBerechnung$, this._beitragBoxArtefakt$]).pipe(
        filter(([berechneteWerte, beitragBoxArtefakt]) => !!beitragBoxArtefakt),
        map(([berechneteWerte, beitragBoxArtefakt]) => {
          const vorgangReferenzBeitragBox = this._calculationService.getVorgangReferenzArtefaktFromBeitragBox(beitragBoxArtefakt);
          if (!!vorgangReferenzBeitragBox) {
            const beitragsBoxCopy = JSON.parse(JSON.stringify(beitragBoxArtefakt));
            if (!!berechneteWerte) {
              beitragsBoxCopy.UIArtefakt.splice(vorgangReferenzBeitragBox.index + 1, 0, ...berechneteWerte.UIArtefakt);
            }
            return beitragsBoxCopy.UIArtefakt;
          }
          return beitragBoxArtefakt.UIArtefakt;
        })
    );
  }

}
